import { URL } from "../environment/variables";

export const getDocumentos = async () => {

    try{
        const response = await fetch(`${URL}/cms/obtenerdocumentos/82736EB3-2DE1-4435-882C-A2AA7513CBB8`, {
            mode: 'cors',
            method: 'GET',
            headers:{
                'Accept': '*/*',
            }
        })
        const json = await response.json()
        return json
    }catch(err){
        console.log(err)
    }

}